var map = {
	"./back.svg": 15651,
	"./burger.svg": 41467,
	"./chat.svg": 76807,
	"./chat_off.svg": 5415,
	"./checkmark.svg": 56814,
	"./checkmark_white.svg": 18849,
	"./copy.svg": 9972,
	"./cross.svg": 50039,
	"./cross_white.svg": 89343,
	"./dashedBg.svg": 56471,
	"./delay.svg": 95186,
	"./delete.svg": 31988,
	"./dmca.svg": 70325,
	"./elite.svg": 22355,
	"./ext_link.svg": 38073,
	"./ext_link_white.svg": 55238,
	"./flex_left.svg": 76084,
	"./flex_right.svg": 22925,
	"./gear.svg": 2246,
	"./home.svg": 9526,
	"./home_logo.svg": 90738,
	"./home_logo_outlined.svg": 54240,
	"./infos.svg": 347,
	"./kick.svg": 36508,
	"./king.svg": 93665,
	"./minus.svg": 31152,
	"./minus2.svg": 43879,
	"./multiplayer.svg": 23662,
	"./music.svg": 69029,
	"./mute.svg": 62055,
	"./obs.svg": 45193,
	"./offline.svg": 28313,
	"./pause.svg": 92400,
	"./play.svg": 6223,
	"./play_withBg.svg": 92210,
	"./playlist.svg": 64054,
	"./plus.svg": 88815,
	"./plus2.svg": 704,
	"./refresh.svg": 14898,
	"./remove.svg": 36019,
	"./share.svg": 72133,
	"./show.svg": 75959,
	"./shrug.svg": 11223,
	"./solo.svg": 87342,
	"./song.svg": 99914,
	"./spotify.svg": 36221,
	"./spotify_color.svg": 21014,
	"./star.svg": 49415,
	"./stop.svg": 63640,
	"./stop_square.svg": 85625,
	"./twitch.svg": 85123,
	"./unmute.svg": 17765,
	"./user.svg": 7331,
	"./user_white.svg": 98478,
	"./warning.svg": 88360
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63289;